module.exports = __webpack_public_path__ + "assets/img/mecha-527f61cc.png";